function loadScript( url, callback ) {
    // console.log( `loadScript`, { url, callback });

    // Create a new script element
    let script = document.createElement('script');

    // Set the script's source to the provided URL
    script.src = url;

    // Set the script's type to "text/javascript"
    script.type = 'text/javascript';

    // Attach the script to the document's head
    document.getElementsByTagName('head')[0].appendChild(script);

    if ( !!callback ) {
        script.onload = callback;
    }
}

export { loadScript };
